import { action } from 'easy-peasy'

const _states = {
  loading: false,
  order: {
    orderItem: {},
    isAcceptPrivacyPolicy: false,
    isAcceptMarketing: false,
    isAcceptRefundPolicy: false,
  },
}

const _actions = {
  reset: action(() => {
    return {
      ..._states,
    }
  }),

  setOrder: action((state, payload) => {
    state.order = payload
  }),

  setLoading: action((state, payload) => {
    state.loading = payload
  }),
}

const _thunks = {}

const bookingModal = {
  ..._states,
  ..._actions,
  ..._thunks,
}

export default bookingModal
